import React from 'react';
import Typography from '@material-ui/core/Typography';

import { repositories, } from 'api';
import { Box } from '@material-ui/core';

const TYPE_LABELS = Object.freeze({
    [repositories.products.CollectionTypes.PRODUCTS_PRODUCT_ITEM_MAP.BOOK]: 'książka',
    [repositories.products.CollectionTypes.PRODUCTS_PRODUCT_ITEM_MAP.GRANT_SET]: 'książki',
    [repositories.products.CollectionTypes.PRODUCTS_PRODUCT_ITEM_MAP.GRANT_APP]: 'program komputerowy',
});

type Props = {
    type: repositories.products.CollectionTypes.ProductsProductItemType,
};

const ProductsItemLabel: React.FC<Props> = ({ type }) => (
    <Box height="26px" display="flex" alignItems="center">
        <Typography gutterBottom
                    variant="caption">
            {TYPE_LABELS[type as keyof typeof TYPE_LABELS] ?? ''}
        </Typography>
    </Box>
);

export default ProductsItemLabel;
